export class Domains {
	public static readonly MIKROTIK_DOMAIN = "Mikrotik";
	public static readonly CDR_DOMAIN = "CDR";
	public static readonly KEEPALIVE_DOMAIN = "KeepAlive";
	public static readonly RELAY_DOMAIN = "Relay";
	public static readonly PORTAL_DOMAIN = "Home";
	public static readonly CUSTOMER_DOMAIN = "Customer";
	public static readonly REPORTS_DOMAIN = "Reports";
	public static readonly TELTONIKA_DOMAIN = "Teltonika";
	public static readonly CONTRACTORS_DOMAIN = "Contractors";
	// Global Access Domains

	// TODO:

	// public static ERROR_DOMAIN = "error";
	// public static REGISTER_DOMAIN = "Register";
	// public static FORGOT_PASSWORD_DOMAIN = "ForgotPassword";
	// public static RESET_PASSWORD_DOMAIN = "ResetPassword";
	// public static HIPHOME_DOMAIN = "HIPHome";
	// public static PROFILE_DOMAIN = "Profile";
}

export class DomainRoles {
	public static readonly USER_ROLES = ["User"];
	public static readonly ADMIN_ROLES = ["Admin"];
	public static readonly REPORTING_ROLES = ["Reporting"];
	public static readonly GRAPHING_ROLES = ["Graphing"];
	public static readonly SUPER_USER_ROLES = ["Super User"];
	public static readonly REGISTERED_ROLES = ["Registered"];
	public static readonly REMOTE_ACCESS_ROLES = ["Remote Access"];

	public static readonly PORTAL_ROLES = [].concat(
		DomainRoles.SUPER_USER_ROLES,
		DomainRoles.REGISTERED_ROLES,
		DomainRoles.USER_ROLES,
	);
	public static readonly CDR_ROLES = [].concat(
		DomainRoles.ADMIN_ROLES,
		DomainRoles.USER_ROLES,
		DomainRoles.GRAPHING_ROLES,
		DomainRoles.REPORTING_ROLES,
	);
	public static readonly KEEPALIVE_ROLES = [].concat(
		DomainRoles.ADMIN_ROLES,
		DomainRoles.USER_ROLES,
		DomainRoles.GRAPHING_ROLES,
		DomainRoles.REPORTING_ROLES,
	);
	public static readonly MIKROTIK_ROLES = [].concat(
		DomainRoles.ADMIN_ROLES,
		DomainRoles.USER_ROLES,
		DomainRoles.GRAPHING_ROLES,
		DomainRoles.REPORTING_ROLES,
	);
	public static readonly RELAY_ROLES = [].concat(
		DomainRoles.ADMIN_ROLES,
		DomainRoles.USER_ROLES,
		DomainRoles.GRAPHING_ROLES,
		DomainRoles.REPORTING_ROLES,
	);
}
